import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppLayoutComponent } from "./layout/app.layout.component";
import { AuthenticationGuard } from './shared/helpers/auth.guard';
import { AppLayout2Component } from './layout/app.layout2.component';
import { UserGuard } from './shared/helpers/user.guard';
import { TesteeGuard } from './shared/helpers/testee.guard';

const routes: Routes = [
    { path: '', redirectTo: 'auth', pathMatch: 'full' },
    { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
    {
        path: 'app', component: AppLayoutComponent, canActivate: [AuthenticationGuard, UserGuard],
        children: [
            { path: '', loadChildren: () => import('./main/main.module').then(m => m.MainModule) }
        ]
    },
    {
        path: 'testing', component: AppLayout2Component, canActivate: [AuthenticationGuard, TesteeGuard],
        children: [
            { path: '', loadChildren: () => import('./testing/testing.module').then(m => m.TestingModule) }
        ]
    },
    { path: '**', redirectTo: 'auth' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
